export const getCurlInstallation = (secret, wallet, payout, id) => 
`curl -X POST https://api.nftiz.com/commission \\
  -h "X-Secret-Key: ${secret}" \\
  -d wallet=${wallet} \\
  -d amount=${payout} \\
  -d offer=${id}
`;

export const getJavascriptInstallation = (secret, wallet, payout, id) => 
`const axios = require('axios');

axios({
  method: 'POST',
  url: 'https://api.nftiz.com/commission',
  headers: {
    X-Secret-Key: '${secret}'
  },
  data: {
    wallet: '${wallet}',
    amount: ${payout},
    offer: '${id}'
  }
});
`;
